import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type CreateWorkerMutationVariables = {
  input?: Types.Maybe<Types.WorkerInsertType>
};


export type CreateWorkerMutation = (
  { __typename?: 'Mutation' }
  & { createWorker: (
    { __typename?: 'Worker' }
    & Pick<Types.Worker, '_id' | 'firstName' | 'lastName'>
  ) }
);

export type ReadWorkersAdminQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadWorkersAdminQuery = (
  { __typename?: 'Query' }
  & { workers: Array<(
    { __typename?: 'Worker' }
    & Pick<Types.Worker, '_id' | 'type' | '_deleted' | 'firstName' | 'lastName' | 'name' | 'department' | 'company' | 'annotation' | 'qBasic' | 'qTurbo' | 'qSupersport' | 'qNordschleife' | 'qMuLow' | 'qOffroad' | 'inactive'>
  )> }
);

export type UpdateWorkerMutationVariables = {
  id?: Types.Maybe<Types.Scalars['ID']>,
  update?: Types.Maybe<Types.WorkerSetType>
};


export type UpdateWorkerMutation = (
  { __typename?: 'Mutation' }
  & { updateWorker: Array<(
    { __typename?: 'Worker' }
    & Pick<Types.Worker, '_id' | 'type' | 'firstName' | 'lastName' | 'name' | 'department' | 'company' | 'annotation' | 'qBasic' | 'qTurbo' | 'qSupersport' | 'qNordschleife' | 'qMuLow' | 'qOffroad'>
  )> }
);

export type DeleteWorkerMutationVariables = {
  ids?: Types.Maybe<Array<Types.Scalars['ID']>>
};


export type DeleteWorkerMutation = (
  { __typename?: 'Mutation' }
  & { deleteWorker: Array<(
    { __typename?: 'Worker' }
    & Pick<Types.Worker, '_id' | '_deleted'>
  )> }
);

export const CreateWorkerDocument = gql`
    mutation CreateWorker($input: WorkerInsertType) {
  createWorker(input: $input) {
    _id
    firstName
    lastName
  }
}
    `;
export type CreateWorkerMutationFn = ApolloReactCommon.MutationFunction<CreateWorkerMutation, CreateWorkerMutationVariables>;

    export function useCreateWorkerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWorkerMutation, CreateWorkerMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateWorkerMutation, CreateWorkerMutationVariables>(CreateWorkerDocument, baseOptions);
    };
export type CreateWorkerMutationHookResult = ReturnType<typeof useCreateWorkerMutation>;
export type CreateWorkerMutationResult = ApolloReactCommon.MutationResult<CreateWorkerMutation>;
export type CreateWorkerMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWorkerMutation, CreateWorkerMutationVariables>;
export const ReadWorkersAdminDocument = gql`
    query ReadWorkersAdmin($search: String) {
  workers(filter: {OR: [{firstName: {REGEX: $search, OPTIONS: "i"}}, {lastName: {REGEX: $search, OPTIONS: "i"}}, {department: {REGEX: $search, OPTIONS: "i"}}]}) {
    _id
    type
    _deleted
    firstName
    lastName
    name
    department
    company
    annotation
    qBasic
    qTurbo
    qSupersport
    qNordschleife
    qMuLow
    qOffroad
    inactive
  }
}
    `;

    export function useReadWorkersAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadWorkersAdminQuery, ReadWorkersAdminQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadWorkersAdminQuery, ReadWorkersAdminQueryVariables>(ReadWorkersAdminDocument, baseOptions);
    };
      export function useReadWorkersAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadWorkersAdminQuery, ReadWorkersAdminQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadWorkersAdminQuery, ReadWorkersAdminQueryVariables>(ReadWorkersAdminDocument, baseOptions);
      };
      
export type ReadWorkersAdminQueryHookResult = ReturnType<typeof useReadWorkersAdminQuery>;
export type ReadWorkersAdminQueryResult = ApolloReactCommon.QueryResult<ReadWorkersAdminQuery, ReadWorkersAdminQueryVariables>;
export const UpdateWorkerDocument = gql`
    mutation UpdateWorker($id: ID, $update: WorkerSetType) {
  updateWorker(filter: {_id: {EQ: $id}}, update: {set: $update}) {
    _id
    type
    firstName
    lastName
    name
    department
    company
    annotation
    qBasic
    qTurbo
    qSupersport
    qNordschleife
    qMuLow
    qOffroad
  }
}
    `;
export type UpdateWorkerMutationFn = ApolloReactCommon.MutationFunction<UpdateWorkerMutation, UpdateWorkerMutationVariables>;

    export function useUpdateWorkerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWorkerMutation, UpdateWorkerMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateWorkerMutation, UpdateWorkerMutationVariables>(UpdateWorkerDocument, baseOptions);
    };
export type UpdateWorkerMutationHookResult = ReturnType<typeof useUpdateWorkerMutation>;
export type UpdateWorkerMutationResult = ApolloReactCommon.MutationResult<UpdateWorkerMutation>;
export type UpdateWorkerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWorkerMutation, UpdateWorkerMutationVariables>;
export const DeleteWorkerDocument = gql`
    mutation DeleteWorker($ids: [ID!]) {
  deleteWorker(filter: {_id: {IN: $ids}}) {
    _id
    _deleted
  }
}
    `;
export type DeleteWorkerMutationFn = ApolloReactCommon.MutationFunction<DeleteWorkerMutation, DeleteWorkerMutationVariables>;

    export function useDeleteWorkerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWorkerMutation, DeleteWorkerMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteWorkerMutation, DeleteWorkerMutationVariables>(DeleteWorkerDocument, baseOptions);
    };
export type DeleteWorkerMutationHookResult = ReturnType<typeof useDeleteWorkerMutation>;
export type DeleteWorkerMutationResult = ApolloReactCommon.MutationResult<DeleteWorkerMutation>;
export type DeleteWorkerMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteWorkerMutation, DeleteWorkerMutationVariables>;